import {
  LifetimeOverlay,
  LifetimeOverlayBackgroundColors,
  toLifetimeOverlayBackgroundColor,
} from "@playlive/overlay-core/overlays/lifetime";
import { deepSignal } from "deepsignal";
import { useCallback, useMemo } from "preact/hooks";
import Picker from "@/components/input/picker.input.jsx";
import CustomizeSection from "@/components/overlays/shared/customize-section.jsx";
import LinkSetup from "@/components/overlays/social/link-setup/link-setup.jsx";
import ScaledOverlayWrapper from "@/components/overlays/wrapper/scaled-overlay-wrapper.jsx";
import ColorPicker from "@/components/pickers/color-picker/color.picker.jsx";
import ColorPickerLabel from "@/components/pickers/color-picker/color-picker-label.jsx";
import useCommon from "@/hooks/useCommon.js";
import { CHARITY } from "@/util/const.js";

const config = deepSignal({
  charityType: CHARITY.TILTIFY,
  bgColor: "default-red",
  displayTimer: "0",
});

export default function LifetimeRaisedPage() {
  const { overlayInfo, overlayURL, setConfigState } = useCommon({
    config,
    forceTiltify: true,
    addTiltifyCampaign: false,
  });

  const filterColors = useCallback(
    (color) => LifetimeOverlayBackgroundColors.find((c) => c === color),
    [],
  );

  const timerOptions = useMemo(
    () => [
      {
        value: "5",
        name: "Five minutes",
      },
      {
        value: "10",
        name: "Ten minutes",
      },
      {
        value: "15",
        name: "Fifteen minutes",
      },
      {
        value: "0",
        name: "Always",
      },
    ],
    [],
  );

  return (
    <div className="w-full overflow-x-hidden">
      <div className="flex flex-col overflow-hidden">
        <div className="example_overlay select-none overflow-hidden w-full">
          <ScaledOverlayWrapper className="h-[550px]" allowScaling={false} defaultScale="scale-100">
            <LifetimeOverlay
              backgroundColor={toLifetimeOverlayBackgroundColor(config.bgColor)}
              displayTimer={config.displayTimer}
              currentAmount={1000}
              animationDelay={0}
            />
          </ScaledOverlayWrapper>
        </div>

        <div>
          <CustomizeSection title="Appearance">
            <ColorPickerLabel color={config.bgColor} />
            <ColorPicker
              fieldName="bgColor"
              currentColor={config.bgColor}
              filterFunction={filterColors}
              onChange={setConfigState}
            />
          </CustomizeSection>
          <CustomizeSection title="Misc." className="flex-grow">
            <Picker
              items={timerOptions}
              fieldName="displayTimer"
              onChange={setConfigState}
              currentValue={config.displayTimer}
              labelText="Visibility Settings"
              // description="Set amount of time to rotate future milestones visibility in and out on the overlay"
              description="Set how often your lifetime total automatically appears and disappears, or keep it always visible."
            />
          </CustomizeSection>

          {/* Charity Section Placeholder */}
        </div>
      </div>

      <div className="w-full xl:mt-4">
        <LinkSetup
          showTiltifyCampaignSelector={false}
          constrainWidth={false}
          charityType={CHARITY.TILTIFY}
          obsDimensions={overlayInfo.obsDimensions}
          overlayName={overlayInfo.name}
          overlayURL={overlayURL}
        />
      </div>
    </div>
  );
}
